export default "__VITE_ASSET__158139e0__"